import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { CallLogsComponent } from './components/call-logs/call-logs.component';

const routes: Routes = [

    // { path: '', redirectTo: 'dispatch', pathMatch: 'full'},
    // Admin routes
    {
        path: 'connect',
        // canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
          {
            path: '',
            loadChildren: () => import('./components/call-logs/call-logs.module').then(m => m.CallLogsModule)
          }
        ]
        // children: [
        //     {
        //     path: '', component: CallLogsComponent,
        //     data: { module: 'ZUPER_CONNECT' }
        //   }
        // ]
    },
    { path: 'connect', redirectTo: 'connect' },
    { path: '', redirectTo: 'connect', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
